import { BLOCKS } from '@contentful/rich-text-types'
import {
  AssetOptionsContext,
  type AssetOptionsContextProps,
  DEFAULT_MAX_SVG_HEIGHT,
  DEFAULT_MIN_SVG_WIDTH,
} from '@contexts/asset-options'
import { ContentType } from '@entries/content-types'
import ContentfulAsset from '@entries/contentful-asset'
import { withDisplayName } from '@hocs/with-display-name'
import { document } from '@render-node/refresh-document'
import { Entry } from '@resolvers/entry'
import RichText from '@resolvers/rich-text'
import { defaultRichTextFieldOptionsDeprecated } from '@resolvers/rich-text/default-rich-text-field-options-deprecated'
import { Card } from '@ui/card/card'
import { graphql } from 'gatsby'
import React from 'react'

const assetOptions: AssetOptionsContextProps = {
  width: 'auto',
  height: '100%',
  minSvgWidth: DEFAULT_MIN_SVG_WIDTH,
  maxSvgHeight: DEFAULT_MAX_SVG_HEIGHT,
  objectFit: 'cover',
  alt: '',
  display: 'inline',
}

const ContentfulContentArticleRefreshImageBento: Utils.EntryFC<
  Queries.ContentfulContentArticleRefreshImageBentoFragment
> = ({ content: { image, content }, fieldInspectorProps }) => {
  const hasImage = Boolean(image)
  return (
    <Card className="!rounded-[24px] p-[24px]">
      {hasImage && (
        <div
          className="h-[230px] min-h-[230px] w-full"
          {...fieldInspectorProps({
            fieldId: 'image',
          })}
        >
          <AssetOptionsContext.Provider value={assetOptions}>
            <Entry
              content={image}
              mapping={{
                [ContentType.ContentfulAsset]: ContentfulAsset,
              }}
            />
          </AssetOptionsContext.Provider>
        </div>
      )}
      <div className="flex h-full flex-col pt-[36px] text-center">
        <div>
          {content && (
            <RichText
              {...fieldInspectorProps({
                fieldId: 'content',
              })}
              content={content}
              options={{
                ...defaultRichTextFieldOptionsDeprecated,
                renderNode: {
                  ...defaultRichTextFieldOptionsDeprecated.renderNode,
                  [BLOCKS.DOCUMENT]: document,
                },
              }}
            />
          )}
        </div>
      </div>
    </Card>
  )
}

export const query = graphql`
  fragment ContentfulContentArticleRefreshImageBento on Contentful4TmD9EihHakmKMkEwKaUwQ {
    ...ContentfulEntry
    content {
      ...ContentfulContentArticleContent
    }
    image {
      ...ContentfulDefaultAsset
    }
  }
`

export default withDisplayName(
  ContentfulContentArticleRefreshImageBento,
  'ContentfulContentArticleRefreshImageBento'
)
